import React from 'react';

const ProjectsPage: React.FC = () => {
  return (
    <div style={{ paddingTop: '70px', minHeight: '100vh', padding: '120px 20px 80px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#000' }}>
          New Wave Projects Limited
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#666', lineHeight: '1.6', marginBottom: '40px' }}>
          Partnering with third-party specialists to engineer and install comprehensive 
          networking and communication solutions. We manage complex projects from 
          conception to completion with precision and expertise.
        </p>
        
        <div style={{ marginTop: '40px', textAlign: 'left', maxWidth: '600px', margin: '40px auto 0' }}>
          <h3 style={{ color: '#000', marginBottom: '20px', textAlign: 'center' }}>Our Services:</h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>Project Management</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>End-to-end project management from planning to execution</p>
            </div>
            
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>Engineering Solutions</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Custom engineering solutions for complex technical challenges</p>
            </div>
            
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>Installation Services</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Professional installation of networking and communication systems</p>
            </div>
            
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
              <h4 style={{ color: '#000', marginBottom: '10px' }}>Technical Consulting</h4>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Expert technical guidance for strategic decision making</p>
            </div>
          </div>
        </div>
        
        <div style={{ marginTop: '60px' }}>
          <a 
            href="/#contact" 
            style={{ 
              background: '#000', 
              color: '#fff', 
              padding: '12px 24px', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontSize: '1rem',
              fontWeight: '500'
            }}
          >
            Get In Touch
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProjectsPage;
